import script from "./AllowExternalSharedStatusChangeConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllowExternalSharedStatusChangeConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./AllowExternalSharedStatusChangeConfirmModal.vue?vue&type=style&index=0&id=3c26b052&lang=css"
import "./AllowExternalSharedStatusChangeConfirmModal.vue?vue&type=style&index=1&id=3c26b052&lang=scss"

const __exports__ = script;

export default __exports__